export default function BadgeCounterModelsMobile({
  count,
  capabilities = false,
  onClick,
}) {
  return (
    <div
      className="inline-flex items-center px-3 py-1 bg-indigo-100 text-indigo-800 rounded-full text-sm font-medium"
      onClick={onClick}
    >
      {/* {Boolean(capabilities) && (
        <>
          <SparklesIcon className="w-4 h-4 mr-1" />
        </>
      )} */}
      <span>{count}</span>
    </div>
  );
}
